/* eslint-disable @typescript-eslint/naming-convention */
export const SET_USER = "@USERS/SET_USER";
export type SET_USER = typeof SET_USER;

export const PURGE_USERS = "@USERS/PURGE_USERS";
export type PURGE_USERS = typeof PURGE_USERS;

export const SET_USER_ACCESSIBLE_ORDER_VARIANTS = "@USERS/SET_USER_ACCESSIBLE_ORDER_VARIANTS";
export type SET_USER_ACCESSIBLE_ORDER_VARIANTS = typeof SET_USER_ACCESSIBLE_ORDER_VARIANTS;
